import * as e from "react";
import i from "@appchoose/cn";
import * as r from "@radix-ui/react-radio-group";
const n = e.forwardRef(({ className: t, ...o }, a) => /* @__PURE__ */ e.createElement(
  r.Root,
  {
    className: i("group/radio-container grid gap-2", t),
    ...o,
    ref: a
  }
));
n.displayName = r.Root.displayName;
const s = e.forwardRef(({ className: t, ...o }, a) => /* @__PURE__ */ e.createElement(
  r.Item,
  {
    ref: a,
    className: i(
      "peer aspect-square h-5.5 w-5.5 rounded-full border border-gray-700 text-gray-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-green-900/30 disabled:cursor-not-allowed disabled:opacity-50 group-[&[aria-invalid=true]]/radio-container:border-red-600 data-[state=checked]:text-green-900",
      t
    ),
    ...o
  },
  /* @__PURE__ */ e.createElement(r.Indicator, { className: "flex items-center justify-center" }, /* @__PURE__ */ e.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "size-3 fill-current text-current transition duration-300"
    },
    /* @__PURE__ */ e.createElement("circle", { cx: "12", cy: "12", r: "10" })
  ))
));
s.displayName = r.Item.displayName;
export {
  n as RadioGroup,
  s as RadioGroupItem,
  n as default
};
